import CompanyAccountsTable from './company-accounts-table';

export default CompanyAccountsTable;
